import { Avatar, Col, Divider, Row, Tag } from 'antd';
import { FolderOpenOutlined, FolderOutlined } from '@ant-design/icons';
import React from 'react';

const SupportedResourceCard = props => {
  const setSelectedResource = resource => {
    props.setSelectedResource(resource);
  };

  const getTagColor = () => {
    let tagColor = 'green';

    if (props.resource.ig === 'CARIN-BB') {
      tagColor = 'purple';
    } else if (props.resource.ig === 'DaVinci PDex') {
      tagColor = 'blue';
    }

    return tagColor;
  };

  const isResourceSelected = name => {
    const selectedResourceNameDisplay = props.selectedResource.resourceName.replace(
      'Explanation Of Benefit',
      'EOB',
    );
    return selectedResourceNameDisplay === name;
  };

  const resourceNameDisplay = props.resource.resourceName.replace('Explanation Of Benefit', 'EOB');
  const backgroundColor = isResourceSelected(resourceNameDisplay) ? 'rgba(243,244,246)' : 'none';
  const icon = isResourceSelected(resourceNameDisplay) ? (
    <FolderOpenOutlined />
  ) : (
    <FolderOutlined />
  );
  const color = getTagColor();

  return (
    <>
      <Row
        justify="space-between"
        style={{ backgroundColor, padding: 20 }}
        onClick={() => setSelectedResource(props.resource)}
        data-cy={`card-${resourceNameDisplay}`}
      >
        <Col>
          {resourceNameDisplay} <br />
          {props.resource.ig && <Tag color={color}>{props.resource.ig}</Tag>}
        </Col>
        <Col>
          {!props.count && icon}
          {props.count && (
            <Avatar style={{ color: '#ffffff', backgroundColor: '#bcbcbc', fontWeight: 'bold' }}>
              {props.count[props.getResourceType(props.resource)]}
            </Avatar>
          )}
        </Col>
      </Row>
      <Divider style={{ margin: 0 }} />
    </>
  );
};

export default SupportedResourceCard;
